/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import isArray from 'lodash/isArray';
import { connect } from 'react-redux';

import MenuItem from './MenuItem';
import Return from '../icons/menu/Return';

import { hasActiveUrl } from '../../lib/utils';

import * as AppPropTypes from '../../lib/PropTypes';

import styles from '../../../styles/menus/menu.scss';

const propTypes = {
    items: AppPropTypes.menuItems,
    url: PropTypes.string,
    color: AppPropTypes.color,
    theme: PropTypes.string,
    hasReturn: PropTypes.bool,
    onClick: PropTypes.func,
    className: PropTypes.string,
};

const defaultProps = {
    items: [],
    url: null,
    color: null,
    theme: null,
    hasReturn: false,
    onClick: null,
    className: null,
};

const Menu = ({ items, url, color, theme, hasReturn, onClick, className }) => (
    <div
        className={classNames([
            styles.container,
            {
                [className]: className !== null,
            },
        ])}
    >
        <ul className={styles.items}>
            {hasActiveUrl(url, items).map((item, index) => {
                const hasChildren = item && item.children && isArray(item.children);
                const children = hasChildren ? (
                    <div
                        className={classNames([
                            styles.children,
                            {
                                [styles.hasMargin]: !hasReturn,
                            },
                        ])}
                    >
                        {hasActiveUrl(url, item.children).map((it, idx) => (
                            <div className={styles.child} key={`it-${index + 1}-${idx + 1}`}>
                                {hasReturn ? <Return className={styles.childElement} /> : null}
                                <MenuItem
                                    className={styles.childElement}
                                    {...it}
                                    index={idx}
                                    color={color}
                                    theme={theme}
                                    isChild
                                    onClick={onClick}
                                    hasReturn={hasReturn}
                                />
                            </div>
                        ))}
                    </div>
                ) : null;
                return (
                    <div className={styles.item} key={`it-${index + 1}`}>
                        <MenuItem
                            {...item}
                            index={index}
                            color={color}
                            theme={theme}
                            onClick={onClick}
                        />
                        {children}
                    </div>
                );
            })}
        </ul>
    </div>
);

Menu.propTypes = propTypes;
Menu.defaultProps = defaultProps;

const WithStateContainer = connect(({ site: { page } }) => ({
    url: page ? page.url : null,
    // color: mergeProps.color ? mergeProps.color : color,
    // theme: mergeProps.theme ? mergeProps.theme : theme,
}))(Menu);

export default WithStateContainer;
